/* eslint-disable no-console */
import { Wrap } from './styles';

import Slider from '@material-ui/core/Slider';
import { useState, useEffect } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
 import { useMap } from 'views/MapView/hooks';

export const Opacity = ({
  layerId, 
  leafletLayer,
  opacity,
  fillOpacity,
  type,
  dataType,
  service = null
}) => {
        
    const [opacityLevel, setOpacityLevel] = useState(100);
    const [fillOpacityLevel, setFillOpacityLevel] = useState(20);
    const { changeLayerOpacity } = useMap();

    let layerType = false
    if(type === 'criada' || type === 'importada' || service === 'WFS'){
      if(dataType === 'Polygon' || dataType === 'MultiPolygon' || dataType === 'GeometryCollection'){
        layerType = true
      }
    }
    
    useEffect(() =>{      
      setOpacityLevel(opacity * 100)
      // Seta preenchimento para camadas criadas/importadas da familia polygon
      if(layerType){
        setFillOpacityLevel(fillOpacity * 100)
      }else{
      // Seta um valor default para todos os outros tipos
        setFillOpacityLevel(100)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    /** Altera a opacidade da layer no mapa */
    useEffect(() => {
      if (leafletLayer) {        
        changeLayerOpacity(layerId, opacityLevel / 100, fillOpacityLevel / 100, true);
      }    
    }, [leafletLayer, layerId, changeLayerOpacity, opacityLevel, fillOpacityLevel]);

    return (              
      <Wrap>
        {layerType ? 
          <>
            <div className="opacity-control layer">
              <span className='text-opacity'>Contorno</span>
            </div>
            <div className="opacity-control">
              <Slider
                min={0.1}
                max={100}
                value={opacityLevel}
                onChange={(e, v) => setOpacityLevel(v)}
              />
              <div className="opacity-value">
                <input
                  type="number"
                  min="0.1"
                  max="100"
                  defaultValue="100"
                  name="opacity-value"
                  value={opacityLevel}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value > 100 ? 100 : value < 0.1 ? 0.1 : value;
                    setOpacityLevel(value);
                  }}
                />
                <span>%</span>
              </div>
            </div>
            <div className='line'></div>
            <div className="opacity-control">
                <span className='text-opacity'>Preenchimento</span>
            </div>
            <div className="opacity-control fill">
              <Slider
                defaultValue="20"
                value={fillOpacityLevel}
                onChange={(e, v) => setFillOpacityLevel(v)}
              />
              <div className="opacity-value">
                <input
                  type="number"
                  min="0.1"
                  max="100"
                  name="opacity-value"
                  value={fillOpacityLevel}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value > 100 ? 100 : value < 0.1 ? 0.1 : value;
                    setFillOpacityLevel(value);
                  }}
                />
                <span>%</span>
              </div>
            </div>
          </>
          :
          <>
            <div className="opacity-control">
              <Slider
                min={0.1}
                max={100}                
                defaultValue="100"
                value={opacityLevel}
                onChange={(e, v) => setOpacityLevel(v)}
              />
              <div className="opacity-value">
                <input
                  type="number"
                  min="0.1"
                  max="100"
                  name="opacity-value"
                  value={opacityLevel}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value > 100 ? 100 : value < 0.1 ? 0.1 : value;
                    setOpacityLevel(value);
                  }}
                />
                <span>%</span>
              </div>
            </div>
          </>
        }                                
      </Wrap>
    )
}